import React from 'react'
import { Form, Button } from 'react-bootstrap'
import { useFileInput } from '../../hooks/useFileInput'
import { uploadBytes, uploadString  } from 'firebase/storage'
import { imgRef, infoRef } from '../../firebase'
import { useImages } from '../../contexts/imageContext'
import { useInput } from '../../hooks/useInput'

export default function UploadAbout() {
    const [about, setAbout] = useImages()
    const [info, handleInfo] = useInput()
    const [file, handleFile] = useFileInput()
    const uploadFile = async(e)=>{
        e.preventDefault()
        try{
            await uploadBytes(imgRef, file)
            await uploadString(infoRef, info)
        }
        catch(error){
            console.log(error)
        }
    }
  return (
    <Form onSubmit={uploadFile} className="mb-5">
        <Form.Group>
            <Form.Label>About Picture</Form.Label>
            <Form.Control type='file' files={file} onChange={handleFile}></Form.Control>
        </Form.Group>

        <Form.Group className='mt-3'>
            <Form.Label>Home Info</Form.Label>
            <Form.Control as={"textarea"} value={info} onChange={handleInfo}></Form.Control>
        </Form.Group>
        <Button type='submit' className='mt-2'>Upload</Button>
    </Form>
  )
}
